import React, { useState, useEffect } from "react";
import {
  Box,
  Typography,
  TextField,
  Select,
  MenuItem,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Button,
  Pagination,
  InputAdornment,
  Grid,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import transactionsData from "../../../Data/transactions.json";

const Transactions = () => {
  const [transactions, setTransactions] = useState(transactionsData);
  const [search, setSearch] = useState("");
  const [methodFilter, setMethodFilter] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 7;

  useEffect(() => {
    let filteredData = transactionsData;

    if (search) {
      filteredData = filteredData.filter((item) =>
        item.id.toLowerCase().includes(search.toLowerCase())
      );
    }

    if (methodFilter) {
      filteredData = filteredData.filter(
        (item) => item.method === methodFilter
      );
    }

    setTransactions(filteredData);
  }, [search, methodFilter]);

  const handlePageChange = (event, page) => {
    setCurrentPage(page);
  };

  const paginatedData = transactions.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  return (
    <Box p={3} component={Paper} elevation={2}>
      <Typography variant="h5" fontWeight="bold" mb={2}>
        Transactions
      </Typography>

      <Box display="flex" gap={2} mb={2}>
        <TextField
          variant="outlined"
          size="small"
          placeholder="Search..."
          fullWidth
          onChange={(e) => setSearch(e.target.value)}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon />
              </InputAdornment>
            ),
          }}
        />
        <Select
          value={methodFilter}
          onChange={(e) => setMethodFilter(e.target.value)}
          displayEmpty
          size="small"
          sx={{ minWidth: 150 }}
        >
          <MenuItem value="">Method</MenuItem>
          <MenuItem value="Amex">Amex</MenuItem>
          <MenuItem value="Master card">Master card</MenuItem>
          <MenuItem value="Paypal">Paypal</MenuItem>
          <MenuItem value="Visa">Visa</MenuItem>
        </Select>
      </Box>

      <Grid container spacing={2}>
        <Grid item xs={12} md={8}>
          <TableContainer component={Paper}>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>Transaction ID</TableCell>
                  <TableCell>Paid</TableCell>
                  <TableCell>Method</TableCell>
                  <TableCell>Date</TableCell>
                  <TableCell>Action</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {paginatedData.map((row, index) => (
                  <TableRow key={index}>
                    <TableCell>{row.id}</TableCell>
                    <TableCell>{row.paid}</TableCell>
                    <TableCell>
                      <Box display="flex" alignItems="center">
                        <img
                          src={row.icon}
                          alt={row.method}
                          width="20"
                          style={{ marginRight: 5 }}
                        />
                        {row.method}
                      </Box>
                    </TableCell>
                    <TableCell>{row.date}</TableCell>
                    <TableCell>
                      <Button variant="outlined" size="small">
                        Details
                      </Button>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Grid>

        <Grid item xs={12} md={4}>
          <Box
            p={2}
            border={1}
            borderRadius={2}
            boxShadow={3}
            sx={{
              backgroundColor: "#f8f9fa",
              minHeight: "300px",
              display: "flex",
              flexDirection: "column",
            }}
          >
            <Typography variant="h6" fontWeight="bold" mb={2}>
              Transaction Details
            </Typography>
            <Typography variant="body2" flexGrow={1}>
              Details about the selected transaction will appear here.
            </Typography>
          </Box>
        </Grid>
      </Grid>

      <Box display="flex" justifyContent="flex-start" alignItems="center" mt={2}>
        <Pagination
          count={Math.ceil(transactions.length / itemsPerPage)}
          page={currentPage}
          onChange={handlePageChange}
          sx={{
            "& .MuiPaginationItem-root": {
              backgroundColor: "transparent",
              borderRadius: 0,
              color: "black",
              "&:hover": {
                backgroundColor: "transparent",
              },
              "&.Mui-selected": {
                backgroundColor: "#3bb77e",
                color: "#fff",
              },
            },
          }}
        />
      </Box>
    </Box>
  );
};

export default Transactions;
